import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useWatch } from 'react-hook-form';
import PropTypes from 'prop-types';
import TermsTitle from 'components/IncorporationOfTerms/Register/FormAtoms/TermsTitle';

export const TermsContents = ({ name, handleOnShow, isOnlyCheck, addBackground }) => {
  const { termsContents } = useSelector(state => state.terms);
  const isOpen = useWatch({ name: `${name}-icon` });
  const [contents, setContents] = useState(null);
  useEffect(() => {
    const termArray = termsContents?.filter(value => value?.trmsCd.includes(name));
    setContents(termArray?.length > 0 ? termArray[termArray.length - 1] : null);
  }, [termsContents]);

  return (
    <>
      {contents && (
        <li className={`${isOpen ? 'open' : 'close'}  `}>
          <TermsTitle
            label={contents.trmsTtl}
            name={contents.trmsCd}
            btnOnClick={() => handleOnShow(`${name}-icon`)}
            isOnlyCheck={isOnlyCheck}
          />
          {addBackground ? (
            <div className="term-text">
              <div
                className="section--terms"
                style={{ fontSize: '13px' }}
                dangerouslySetInnerHTML={{
                  __html: contents.trmsCn,
                }}
              />
            </div>
          ) : (
            <div
              dangerouslySetInnerHTML={{
                __html: contents.trmsCn,
              }}
            />
          )}
        </li>
      )}
    </>
  );
};
TermsContents.propTypes = {
  name: PropTypes.string.isRequired,
  handleOnShow: PropTypes.func.isRequired,
  isOnlyCheck: PropTypes.bool,
  addBackground: PropTypes.bool,
};
TermsContents.defaultProps = { isOnlyCheck: false, addBackground: false };
export default TermsContents;
